import {Inject, Injectable} from '@angular/core';
import {ApiBaseService} from "libs/shared-services/src/lib/api-base.service";
import {ToasterService} from "libs/shared-services/src/lib/toaster.service";
import {environment} from "../../../environments/environment";
import {UserSelfResponse} from "../../models/user-response";
import {BehaviorSubject, Observable} from "rxjs";
import { LocaleService } from 'libs/shared-services/src/lib/locale.service';
import { ReviewListResponse } from './model/review-list-response.model';

@Injectable({
    providedIn: 'root',
})
export class RestaurantReviewsService  {

    private reviewsData$: BehaviorSubject<ReviewListResponse[]> = new BehaviorSubject<ReviewListResponse[]>([]);

    constructor(
        @Inject('env') private environment: any,
        private apiService: ApiBaseService,
        private toasterService: ToasterService,
        private localeService: LocaleService
    ) {
        
    }

    public fetchAPI() {

        const url = environment.API_GET_ORDERS_REVIEWS + "?pageSize=100";

        this.apiService.get(url).subscribe({
            next: (res: any) => {   

                let reviewsList: ReviewListResponse[] = [];
                if (!!res && !!res?.results && res.results.length > 0) {
                    res.results.forEach((review: any) => {
                        let r = Object.assign(new ReviewListResponse(), review);
                        reviewsList.push(r);
                    })                    
                }

                this.setData(reviewsList);
            },
            error: (err) => {
                this.toasterService.showError("Error", err?.error?.message);
            }
        });
    }

    private setData(data: ReviewListResponse[]) {
        this.reviewsData$.next(data);
    }

    public getData$(): Observable<ReviewListResponse[]> {
        return this.reviewsData$;
    }

    public getData(): ReviewListResponse[] {
        return this.reviewsData$.getValue();
    }
}

